import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import WarningTriangleGrey from '@assets/Warning Triangle Grey.png';
import { useAppDispatch } from '@state/configureStore';
import { setIsErrorRoute } from '@state/pageSlice';
import './Error.scss';

interface Props {
    title: string;
    subTitle: string;
    text: string;
}
export const CustomError: FC<Props> = ({ title, subTitle, text }) => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();

    useEffect(() => {
        document.title = t('title.error');
        dispatch(setIsErrorRoute(true));
        return () => {
            dispatch(setIsErrorRoute(false));
        };
    }, [t, dispatch]);

    return (
        <div className="d-flex justify-content-center align-items-center custom-height">
            <div className="d-flex error-block p-5 rounded gap-4">
                <div>
                    <img src={WarningTriangleGrey} alt={title} width={70} height={70} />
                </div>
                <div>
                    <h1 className="fw-semibold">{title}</h1>
                    <h2 className="fw-semibold">{subTitle}</h2>
                    <p className="text mt-4">{text}</p>
                </div>
            </div>
        </div>
    );
};
